import React from 'react';
import { Link } from 'react-router-dom';
import { Heart, ArrowRight } from 'lucide-react';
import { useCart } from '../context/CartContext';
import ProductImage from './ProductImage';

const ProductCard = ({ product }) => {
  const { wishlist, toggleWishlist } = useCart();
  const liked = wishlist.includes(product.id);

  return (
    <div className="group relative bg-white rounded-2xl border border-blue-100 hover:border-blue-300 hover:shadow-2xl hover:shadow-blue-100 hover:-translate-y-1 transition-all duration-300 overflow-hidden">
      {product.badge && (
        <span className="absolute top-3 left-3 z-10 px-2.5 py-1 rounded-full bg-blue-600 text-white text-[10px] font-bold uppercase tracking-wider shadow-md shadow-blue-200">
          {product.badge}
        </span>
      )}
      <button
        onClick={(e) => { e.preventDefault(); toggleWishlist(product.id); }}
        className={`absolute top-3 right-3 z-10 w-9 h-9 rounded-full flex items-center justify-center transition ${liked ? 'bg-blue-600 text-white shadow-md shadow-blue-200' : 'bg-white/90 backdrop-blur text-slate-500 hover:bg-blue-50 hover:text-blue-600 shadow'}`}
        aria-label="Wishlist"
      >
        <Heart className={`w-4 h-4 ${liked ? 'fill-current' : ''}`} />
      </button>

      <Link to={`/produkt/${product.id}`} className="block">
        <div className="relative aspect-square bg-gradient-to-br from-blue-50 via-white to-sky-50 overflow-hidden">
          <div className="absolute inset-0" style={{
            background: `radial-gradient(circle at 30% 20%, ${product.color}18 0%, transparent 55%)`
          }} />
          <ProductImage
            src={product.image}
            alt={product.name}
            name={product.name}
            color={product.color}
            loading="lazy"
            className="absolute inset-0 w-full h-full object-contain p-6 group-hover:scale-110 transition-transform duration-500"
          />
        </div>
      </Link>

      <div className="p-4">
        <div className="text-[10px] font-semibold uppercase tracking-widest text-blue-600 mb-1">{product.dosage}</div>
        <Link to={`/produkt/${product.id}`}>
          <h3 className="font-bold text-slate-900 text-base mb-1.5 hover:text-blue-600 transition line-clamp-1">{product.name}</h3>
        </Link>
        <p className="text-xs text-slate-500 line-clamp-2 min-h-[32px] mb-3">{product.short}</p>

        <Link
          to={`/produkt/${product.id}`}
          className="group/btn inline-flex items-center gap-1.5 text-blue-600 hover:text-blue-700 font-semibold text-sm transition"
        >
          Zobacz produkt
          <ArrowRight className="w-3.5 h-3.5 group-hover/btn:translate-x-1 transition-transform" />
        </Link>
      </div>
    </div>
  );
};

export default ProductCard;
